import {useState, type ReactNode} from "react";

type Props = {
  icon: string;
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
};

export function PdpCollapseCard({icon, title, children, defaultOpen = false}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = `pdp-collapse-${title.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <section className={`pvPdpCollapse${open ? " isOpen" : ""}`}>
      <button
        type="button"
        className="pvPdpCollapse__head"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="pvPdpCollapse__headMain">
          <span className="pvPdpCollapse__icon" aria-hidden="true">
            <i className={`fa ${icon}`} />
          </span>
          <span className="pvPdpCollapse__title">{title}</span>
        </span>
        <span className="pvPdpCollapse__toggle" aria-hidden="true">{open ? "−" : "+"}</span>
      </button>
      <div id={panelId} className="pvPdpCollapse__body" hidden={!open}>
        {children}
      </div>
    </section>
  );
}
